import styled from 'styled-components';

export const TableHeaderStyled = styled.thead``;
